import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';
import { DOCUMENT_LABELS } from '../constans';
import { GenericDocument, TasResponse } from '../document.interface';

@Injectable({
  providedIn: 'root',
})
export class TasDocumentsService {
  constructor(private http: HttpClient) {}

  search(body: any): Observable<GenericDocument> {
    return this.http
      .post<TasResponse[]>(`${environment.serverUrl}/admin/Adm/PurchaseNumber`, body)
      .pipe(map(this.generateDocumentsTas));
  }

  private generateDocumentsTas(data: TasResponse[]): GenericDocument {
    const result = data[0];
    const urls = result.Urls[0];

    return {
      items: urls.map((item, i) => ({
        label: DOCUMENT_LABELS[i],
        link: item,
      })),
    };
  }
}
